module.exports = __webpack_public_path__ + "static/media/N3.af482967.svg";